<template>
  <div class="overlay">
    <div class="form-wrapper">
      <a href="http://piknik.cc" target="_blank">
        <v-img
          class="logo mb-8"
          max-width="100px"
          src="../assets/piknik-logo-white.svg"
          alt="Piknik"
        />
      </a>
      <h2 class="white--text mb-2">{{ $t("changePasswordTitle") }}</h2>
      <p class="white--text mb-8">
        {{ $t("changePasswordDescription") }}
      </p>
      <v-form ref="form" v-model="valid">
        <v-text-field
          dark
          v-model="password1"
          :rules="[rules.required, rules.min, rules.max, rules.password]"
          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="show1 = !show1"
          :type="show1 ? 'text' : 'password'"
          :label="$t('password')"
          rounded
          dense
          filled
        ></v-text-field>
        <v-text-field
          dark
          v-model="password2"
          :rules="[
            rules.required,
            rules.min,
            rules.max,
            rules.password,
            checkSamePasswords,
          ]"
          :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="show2 = !show2"
          :type="show2 ? 'text' : 'password'"
          :label="$t('passwordAgain')"
          rounded
          dense
          filled
        ></v-text-field>
        <v-btn
          v-on:click="changePassword"
          dark
          color="white"
          depressed
          rounded
          :disabled="!valid || snackbar"
          :loading="loading"
          >{{ $t("changePassword") }}</v-btn
        >
      </v-form>
    </div>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ snackbarText }}
      <v-btn
        v-if="respStatus === 200"
        text
        small
        rounded
        @click="$router.push('/login')"
        color="white"
        >{{ $t("logIn") }}</v-btn
      >
      <v-btn
        v-else-if="respStatus === 400"
        text
        small
        rounded
        @click="$router.push('/forgotpassword')"
        color="white"
        >{{ $t("tryAgain") }}</v-btn
      >
    </v-snackbar>
  </div>
</template>

<script>
import userService from "../services/user.service";

export default {
  data() {
    return {
      drawer: null,
      valid: true,
      show1: false,
      password1: "",
      show2: false,
      password2: "",
      rules: {
        required: (value) => !!value || this.$t("requiredField"),
        min: (v) => v.length >= 8 || this.$t("minChars", { chars: 8 }),
        max: (v) => v.length <= 48 || this.$t("maxChars", { chars: 48 }),
        password: (v) =>
          /^(?=.*([A-Z]){1,})(?=.*[0-9]{1,})(?=.*[a-z]{1,}).{8,48}$/.test(v) ||
          this.$t("passwordRegex"),
      },
      loading: false,
      snackbar: false,
      snackbarText: "",
      respStatus: null,
      timeout: 0,
    };
  },
  computed: {
    checkSamePasswords: function () {
      return (
        this.password1 === this.password2 || this.$t("passwordsDoNotMatch")
      );
    },
  },
  methods: {
    async changePassword() {
      this.loading = true;
      const token = this.$route.query.token;
      try {
        const resp = await userService.changePassword(token, this.password1);
        this.respStatus = 200;
        this.snackbarText = this.$t("passwordChangedPleaseLogIn");
        this.snackbar = true;
      } catch {
        this.respStatus = 400;
        this.snackbarText = this.$t("linkExpiredTryAgain");
        this.snackbar = true;
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: #007bff;
  z-index: 10;
  display: flex;
  align-items: center;
  text-align: center;
}

.form-wrapper {
  width: 350px;
  height: auto;
  margin: 0 auto;
}

.form-wrapper .logo {
  margin: 0 auto;
}

@media (max-width: 600px) {
  .form-wrapper {
    padding: 32px;
  }
}

/deep/ .v-input__slot {
  background: rgba(255, 255, 255, 0.2) !important;
}

.form-wrapper /deep/ .v-btn {
  width: 100%;
}

/deep/ .v-btn {
  color: #007bff !important;
}

/deep/ .v-application .error--text {
  color: black !important;
  caret-color: black !important;
}

@media only screen and (max-width: 599px) {
  .overlay {
    overflow-y: scroll;
    text-align: start;
    align-items: flex-start;
    padding-top: 32px;
  }

  .overlay::-webkit-scrollbar {
    display: none;
  }

  .overlay {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  .form-wrapper {
    width: 100%;
  }

  .form-wrapper .logo {
    margin: 0;
  }
}
</style>